<template>
  <b-container fluid>
    <h1>Class Visits</h1>
    <div v-if="loaded">
      <mio-output
        title=""
        :method="ClassVisitSummaryData.method"
        :messages="ClassVisitSummaryData.messages"
        :tables="ClassVisitSummaryData.tables"
        size="half"
      />
    </div>
    <h2 v-else>Loading...</h2>
  </b-container>
</template>

<script>
import { mapActions } from 'vuex';
import { set, get, validateRow, generateCompleteMonthData } from '@/utils/MioHelpers';
import MioOutput from '@/components/MioOutput';

export default {
  name: 'MioClassVisits',
  components: {
    MioOutput,
  },
  data() {
    return {
      loaded: false,
    }
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions({
      GET_MODULE_VISIT_COUNT_COUNTRY: "mio/GET_MODULE_VISIT_COUNT_COUNTRY",
      GET_MAINTENANCE_VISIT_COUNT_COUNTRY: "mio/GET_MAINTENANCE_VISIT_COUNT_COUNTRY",
    }),
    async getData() {
      try {
        await this.GET_MODULE_VISIT_COUNT_COUNTRY();
        await this.GET_MAINTENANCE_VISIT_COUNT_COUNTRY();

        this.loaded = true;
      } catch (err) {
        console.error(err);
      }
    }
  },
  computed: {
    ClassVisitSummaryData: {
      get() {
        let input = {
          module: this.$store.state.mio.moduleVisitCountCountry,
          maintenance: this.$store.state.mio.maintenanceVisitCountCountry,
        };
        let working = {};
        let output = {
          method: "Classroom observations categorised as type: module / maintenance are grouped by year, month and country.",
          messages: [],
        };

        for (let d of ['module', 'maintenance']) {
          let cols = {};
          Object.keys(input[d]).forEach(row => {

            // Validate
            let [valid, message, month, country, count] = validateRow(input[d][row], ['year_month', 'country', 'count']);
            if (!valid) {
              output.messages.push(`record is missing some data: ${message}`);
              return;
            }

            if (count == 0) {
              return;
            }

            // Save country in cols
            cols[country] = {};

            // save count per month-year and country
            for (let c of [country, 'All']) {
              set(working, `${d}.rows.${month}.${c}`, count, 'add');
              set(working, `${d}.yearCounts.${month.substring(0, 4)}.${c}`, count, 'add');
            }
          });

          // Sort rows + cols
          cols = Object.keys(cols).sort().concat('All');
          set(working, `${d}.cols`, cols);
        }

        // Format for output
        output.tables = [{title: 'Module', key: 'module'}, {title: 'Maintenance', key: 'maintenance'}].map(table => ({
          title: `${table.title} Class Visits made`,
          cols: working[table.key].cols,
          rows: Object.keys(working[table.key].rows).reduce((output, month, index, array) => generateCompleteMonthData(output, month, index, array, working[table.key].cols, working[table.key].rows, working[table.key].yearCounts), []).reverse(),
        }));

        // console.log(working);
        // console.log(output);
        return output;
      }
    },
  },
};
</script>
